import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "@/api/statusHTTP";

export const buscarMovimentacoesEstoqueProdutos = async (params) => {
  const url = `compras/produtos/indicadores/movimentacoes-estoque`;
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.movimentacoes;
  }

  logout();
}

export const buscarPerdaDeVendaPorRupturaProdutos = async (params) => {
  const url = `compras/produtos/indicadores/perda-venda-por-ruptura`;
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.rupturas;
  }

  logout();
}
